import React from 'react'
import Gamethir from './Gamethir'

const MyorderThird = () => {
  return (
    <>
    
        <Gamethir/>
    
    </>
  )
}

export default MyorderThird